import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LINE_ITEM } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import { EmptyAddress as EmptyAddressUnified } from './EmptyAddress'
import { EmptyAddressLegacy } from './EmptyAddressLegacy'
import type { EmptyAddressProps } from './useEmptyAddressModel'

export const EmptyAddress: React.FC<EmptyAddressProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LINE_ITEM
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <EmptyAddressUnified {...props} />
  ) : (
    <EmptyAddressLegacy {...props} />
  )
}
